import { render, staticRenderFns } from "./case-collection-state.vue?vue&type=template&id=29cd2b4c&scoped=true"
import script from "./case-collection-state.vue?vue&type=script&lang=ts"
export * from "./case-collection-state.vue?vue&type=script&lang=ts"
import style0 from "./case-collection-state.vue?vue&type=style&index=0&id=29cd2b4c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29cd2b4c",
  null
  
)

export default component.exports